// ProductMoreInfo.jsx
import React from "react";

export default function ProductMoreInfo({ isMobile }) {
  return (
    <div>
      {/* TABS */}
      <div
        style={{
          display: "flex",
          gap: isMobile ? "10px" : "15px",
          marginTop: "40px",
          flexWrap: "wrap",
          justifyContent: isMobile ? "center" : "flex-start",
        }}
      >
        <button style={activeTab}>Description</button>
        {/* <button style={tab}>Reviews</button>
        <button style={tab}>Resources</button> */}
      </div>

      {/* FULL DESCRIPTION */}
      <p style={{ marginTop: "20px" }}>
        Onion powder is a finely ground, dehydrated form of fresh onions,
        offering a concentrated onion flavour in a convenient, shelf-stable
        format.
      </p>

      <h3>Key Features:</h3>
      <ul>
        <li>Made from 100% dehydrated onions</li>
        <li>Fine, free-flowing powder</li>
        <li>Long shelf life</li>
        <li>Consistent flavour and aroma</li>
      </ul>

      <h3>Nutritional Benefits:</h3>
      <ul>
        <li>Ideal for soups, gravies, dry rubs</li>
        <li>Used in ready-to-eat meals</li>
        <li>Rich in vitamins B6 & C</li>
        <li>Low calories, fat-free</li>
      </ul>

      <h3>Applications:</h3>
      <ul>
        <li>Contains vitamins B6 and C</li>
        <li>Source of antioxidants</li>
        <li>Low in calories, fat-free</li>
      </ul>

      <h3>Advantages:</h3>
      <ul>
        <li>Saves time and labor in food preparation</li>
        <li>Easy to measure and blend</li>
        <li>No spoilage compared to fresh onions</li>
        <li>Uniform flavour improves consistency</li>
      </ul>
    </div>
  );
}

const activeTab = {
  padding: "10px 20px",
  background: "green",
  color: "white",
  borderRadius: "8px",
  border: "none",
};

const tab = {
  padding: "10px 20px",
  borderRadius: "8px",
  border: "1px solid #ccc",
};
